import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoChatbubbleEllipsesOutline, IoNotificationsOutline, IoCartOutline, IoChevronBack } from 'react-icons/io5';
import logo from '../../assets/logo-work-transparent.png';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import useRole from '../../hooks/useRole';
import { db } from '../../firebase/config';
import { collection, query, where, onSnapshot, doc, getDoc } from 'firebase/firestore';

const AppHeader = ({ onBack, hideIcons }) => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const { cartCount } = useCart();
  const { isGeneral } = useRole();
  const [totalUnread, setTotalUnread] = useState(0);
  const [notiUnread, setNotiUnread] = useState(0);
  const [headerTitle, setHeaderTitle] = useState('조군산업');
  const myUid = userData?.uid;

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'settings', 'companyInfo'));
        if (snap.exists() && snap.data().headerTitle) {
          setHeaderTitle(snap.data().headerTitle);
        }
      } catch {}
    };
    load();
  }, []);

  useEffect(() => {
    if (!myUid) return;
    const q = query(
      collection(db, 'chatRooms'),
      where('participants', 'array-contains', myUid)
    );
    const unsub = onSnapshot(q, (snap) => {
      let count = 0;
      snap.docs.forEach(doc => {
        const data = doc.data();
        count += (data.unreadCount?.[myUid] || 0);
      });
      setTotalUnread(count);
    });
    return () => unsub();
  }, [myUid]);

  // 읽지 않은 알림 카운트
  useEffect(() => {
    if (!myUid) return;
    const q = query(
      collection(db, 'notifications'),
      where('targetUids', 'array-contains', myUid)
    );
    const unsub = onSnapshot(q, (snap) => {
      let count = 0;
      snap.docs.forEach(d => {
        const data = d.data();
        if (!data.readBy?.includes(myUid)) count++;
      });
      setNotiUnread(count);
    });
    return () => unsub();
  }, [myUid]);

  return (
    <Header>
      <LeftArea>
        {onBack && (
          <BackBtn onClick={onBack}>
            <IoChevronBack size={22} />
          </BackBtn>
        )}
        <Logo src={logo} alt="조군산업 로고" />
        <Title>{headerTitle}</Title>
      </LeftArea>
      {!hideIcons && (
        <IconRow>
          {!isGeneral && (
            <IconBtn onClick={() => navigate('/chat')}>
              <IoChatbubbleEllipsesOutline size={22} />
              {totalUnread > 0 && <Badge $active>{totalUnread}</Badge>}
            </IconBtn>
          )}
          <IconBtn onClick={() => navigate('/orders?tab=cart')}>
            <IoCartOutline size={22} />
            {cartCount > 0 && <Badge $active>{cartCount > 99 ? '99+' : cartCount}</Badge>}
          </IconBtn>
          <IconBtn onClick={() => navigate('/notifications')}>
            <IoNotificationsOutline size={22} />
            {notiUnread > 0 && <Badge $active>{notiUnread > 99 ? '99+' : notiUnread}</Badge>}
          </IconBtn>
        </IconRow>
      )}
    </Header>
  );
};

export default AppHeader;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 20px 0 8px;
  background: white;
`;

const LeftArea = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const BackBtn = styled.button`
  color: #2C3640;
  display: flex;
  align-items: center;
  padding: 4px 4px 4px 0;
`;

const Logo = styled.img`
  height: 68px;
  object-fit: contain;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 700;
  color: #2C3640;
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconBtn = styled.button`
  color: #2C3640;
  display: flex;
  align-items: center;
  padding: 4px;
  position: relative;
`;

const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: ${({ $active }) => $active ? '#E85830' : '#8C9AA4'};
  color: white;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
`;
